import { useTranslation } from "react-i18next";
import bg from '../../img/Academy/risk_management.png';
import Button from "../Button";

const RiskManagement = () => {
    const { t } = useTranslation();
    return (
        <section className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto sm:mx-[20px] relative sm:rounded-[20px] overflow-hidden">
                <div className="relative z-10 sm:p-[40px] px-[20px] py-[60px] md:text-left text-center">
                    <h2 className="open-sans text-[28px] text-[#fff] font-[700]">
                        {t('academy.risk_management.title')}
                    </h2>
                    <h4 className="md:mt-[30px] mt-[25px] mb-[15px] open-sans sm:text-[16px] text-[14px] text-[#fff] font-[700]">
                        {t('academy.risk_management.subtitle')}
                    </h4>
                    <p className="max-w-[420px] md:mx-0 mx-auto font-[300] open-sans sm:text-[16px] text-[14px] text-[#fff]">
                        {t('academy.risk_management.text')}
                    </p>
                    <Button className="mt-[40px]" color="#EFEFEF" text="#0C2780" />
                </div>
                <img className="absolute z-0 inset-0 w-[100%] h-[100%] object-cover object-center" src={bg} alt='' />
            </div>
        </section>
    )
};

export default RiskManagement;
